import { Form, Input, Select, Checkbox } from "antd";
import WrappingModal from "../../../components/Modals/WrappingModal";
import { useGetAccountsQuery } from "../../../redux/Service/Accounts";
import { useGetSellersQuery } from "../../../redux/Service/sellersApi";

interface Props {
  form: any;
  stores: any;
  isEditing: boolean;
  isModalOpen: boolean;
  handleOk: (values: any) => void;
  handleCancel: () => void;
  initialValues?: any;
  loading: boolean;
}

const FormModal = ({
  form,
  stores,
  isEditing,
  isModalOpen,
  handleOk,
  handleCancel,
  initialValues,
  loading,
}: Props) => {
  // Fetch accounts for the AccId select options.
  const { data: accountsData } = useGetAccountsQuery(undefined);
  const accounts = accountsData?.ResponseObject ?? [];
  const accountOptions = accounts.map((acc: any) => ({
    label: acc.AccName,
    value: acc.AccID,
  }));

  // Fetch sellers for the SellerID select options.
  const { data: sellersData } = useGetSellersQuery(undefined);
  const sellers = sellersData?.ResponseObject ?? [];
  const sellerOptions = sellers.map((seller: any) => ({
    label: seller.SellerName, // Adjust based on your seller fields
    value: seller.SellerID,
  }));

  return (
    <WrappingModal
      form={form}
      handleCancel={handleCancel}
      loading={loading}
      isModalOpen={isModalOpen}
      title={isEditing ? "تعديل متجر" : "إضافة متجر"}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleOk}
        initialValues={initialValues}
        className="grid grid-cols-2 gap-3"
      >
        {/* In edit mode, display the StoreID as disabled */}
        {isEditing && (
          <Form.Item
            name="StoreID"
            label="كود المخزن"
            rules={[{ required: true }]}
          >
            <Input disabled />
          </Form.Item>
        )}

        <Form.Item
          name="StoreName"
          label="اسم المخزن"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item name="Address" label="العنوان" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item name="Phone" label="الهاتف">
          <Input />
        </Form.Item>

        <Form.Item name="Mobile" label="الجوال">
          <Input />
        </Form.Item>

        {/* SellerID as a select box using sellers data */}
        <Form.Item name="SellerID" label=" البائع" rules={[{ required: true }]}>
          <Select options={sellerOptions} placeholder="اختر البائع" />
        </Form.Item>

        <Form.Item name="IsStoped" label="متوقف" valuePropName="checked">
          <Checkbox />
        </Form.Item>

        <Form.Item
          name="IsRealStock"
          label="المخزون الحقيقي"
          valuePropName="checked"
        >
          <Checkbox />
        </Form.Item>

        <Form.Item name="AccId" label="الحساب" rules={[{ required: true }]}>
          <Select options={accountOptions} placeholder="اختر الحساب" />
        </Form.Item>
      </Form>
    </WrappingModal>
  );
};

export default FormModal;
